export default __webpack_public_path__ + "static/media/PS5-DE-1.6d45c471.jpg";